import gqlTagGira from 'graphql-tag';
import { VIEW_ITEM_FRAGMENT } from '../calendar-view-items/gql.tsx';

export const QUERY = gqlTagGira`
  query JWMCalendarUnscheduledItems($cloudId: ID!, $jql: String!, $fieldIds: [String]!, $first: Int, $after: String) {
    jira {
      list: jwmViewItems(
        cloudId: $cloudId,
        jql: $jql,
        first: $first,
        after: $after,
      ) {
        __typename
        ... on JiraWorkManagementViewItemConnection {
          edges {
            node {
              ...CalendarViewItem
            }
          }
          totalCount
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }
    }
  }
  ${VIEW_ITEM_FRAGMENT}
`;
